


// import React, { useEffect, useState, useMemo } from "react";
// import "./Usermanagement.css"; // Import the CSS file
// import { Link } from "react-router-dom";
// import ProfessionalUser from "./ProfessionalUser";
// import PostPaidUsers from "./PostPaidUsers";
// import {
//     getAllUsers, getUserProfileByIdAPI,
// } from "../../../Servicefile/userservicefile.jsx";


// // Inline loader hook  
// const useInlineLoader = () => {
//     const [loading, setLoading] = useState(false);
//     const [fadeOut, setFadeOut] = useState(false);

//     const showLoader = () => {
//         setFadeOut(false);
//         setLoading(true);
//     };

//     const hideLoader = () => {
//         setFadeOut(true);
//         setTimeout(() => {
//             setLoading(false);
//             setFadeOut(false);
//         }, 500);
//     };

//     return { showLoader, hideLoader, loading, fadeOut };
// };

// const Userdetails = () => {
//     const [selectedCustomer, setSelectedCustomer] = useState(null);
//     const [data, setData] = useState([]);
//     const [screenWidth, setScreenWidth] = useState(window.innerWidth);
//     const [selectedStatusFilter, setSelectedStatusFilter] = useState("");
//     const [selectedCategoryFilter, setSelectedCategoryFilter] = useState("");
//     const [activeTab, setActiveTab] = useState("User"); // New tab state Daily uses not founded
//     const [searchType, setSearchType] = useState("userId");
//     const [searchQuery, setSearchQuery] = useState("");
//     const [selectedDate, setSelectedDate] = useState("");

//     // Use inline loader 
//     const { showLoader, hideLoader, loading: globalLoading, fadeOut } = useInlineLoader();
//     const filteredData = useMemo(() => {
//         return data.filter(user => {
//             const statusMatch = !selectedStatusFilter ||
//                 user.active === (selectedStatusFilter === "true");
//             const categoryMatch = !selectedCategoryFilter ||
//                 (user.category && user.category.toLowerCase() === selectedCategoryFilter.toLowerCase());
//             return statusMatch && categoryMatch;
//         });
//     }, [data, selectedStatusFilter, selectedCategoryFilter]);



//     const searchFilteredData = useMemo(() => {
//         let result = filteredData;

//         // Search Filter
//         if (searchQuery.trim()) {
//             const query = searchQuery.toLowerCase().trim();

//             result = result.filter((user) => {
//                 const actualField = fieldMapping[searchType];
//                 const fieldValue = user[actualField];

//                 if (!fieldValue) return false;

//                 if (searchType === "mobileNumber") {
//                     const cleanUserMobile = fieldValue.toString().replace(/\D/g, "");
//                     const cleanQuery = query.replace(/\D/g, "");

//                     return (
//                         fieldValue.toString().toLowerCase().includes(query) ||
//                         cleanUserMobile.includes(cleanQuery)
//                     );
//                 }

//                 return fieldValue.toString().toLowerCase().includes(query);
//             });
//         }

//         // Date Filter
//         if (selectedDate) {
//             result = result.filter((user) => {
//                 if (!user.registeredTime) return false;

//                 const userDate = new Date(user.registeredTime)
//                     .toISOString()
//                     .split("T")[0];

//                 return userDate === selectedDate;
//             });
//         }

//         return result;
//     }, [filteredData, searchType, searchQuery, selectedDate]);



//     // Filtered data for User tab Component 

//     const fieldMapping = {
//         userId: "userId",
//         userName: "userName",
//         email: "emailId",
//         mobileNumber: "mobileNumber",
//     };
//     // Tab content mapping
//     const tabContent = {
//         "User": <UserTabContent
//             data={data}
//             selectedStatusFilter={selectedStatusFilter}
//             setSelectedStatusFilter={setSelectedStatusFilter}
//             selectedCategoryFilter={selectedCategoryFilter}
//             setSelectedCategoryFilter={setSelectedCategoryFilter}
//             filteredData={filteredData}
//         />,
//         "Enterprise User": <ProfessionalUser />, // Using the imported component
//     };

//     useEffect(() => {
//         const handleResize = () => setScreenWidth(window.innerWidth);
//         window.addEventListener("resize", handleResize);
//         return () => window.removeEventListener("resize", handleResize);
//     }, []);

//     useEffect(() => {

//         const controller =
//             new AbortController();

//         const authToken =
//             localStorage.getItem("authToken");

//         const fetchUsers =
//             async () => {

//                 try {

//                     showLoader();

//                     // 🔥 SERVICE API
//                     const fetchedData =
//                         await getAllUsers(
//                             authToken
//                         );

//                     // ✅ FILTER ONLY PERSONAL USERS
//                     const personalUsers =
//                         fetchedData.filter(
//                             item =>
//                                 item.userType ===
//                                 "PERSONAL"
//                         );

//                     const dataWithSno =
//                         personalUsers.map(
//                             (item, index) => ({
//                                 ...item,

//                                 sno:
//                                     index + 1,

//                                 category:
//                                     item.category ||
//                                     "N/A",

//                                 subscription:
//                                     item.subscription ||
//                                     "N/A",

//                                 orders:
//                                     typeof item.orders ===
//                                         "number"
//                                         ? item.orders
//                                         : 0,

//                                 last:
//                                     item.lastOrderDate ||
//                                     item.last ||
//                                     "N/A",

//                                 statusAsDeliveryAgent:
//                                     item.status ||
//                                     item.statusAsDeliveryAgent ||
//                                     "N/A",
//                             })
//                         );

//                     setData(dataWithSno);

//                 } catch (err) {

//                     if (
//                         err.name !==
//                         "AbortError"
//                     ) {

//                         console.error(
//                             "Error fetching users:",
//                             err
//                         );
//                     }

//                 } finally {

//                     hideLoader();
//                 }
//             };

//         fetchUsers();

//         return () =>
//             controller.abort();

//     }, []);

//     const openModal = (user) => setSelectedCustomer(user);
//     const closeModal = () => setSelectedCustomer(null);

//     return (
//         <div className="container-fluid p-0 client-managment-data">
//             {/* Global Loader */}
//             {globalLoading && (
//                 <div style={{
//                     position: 'fixed',
//                     top: 0,
//                     left: 0,
//                     right: 0,
//                     bottom: 0,
//                     background: 'rgba(0,0,0,0.95)',
//                     display: 'flex',
//                     alignItems: 'center',
//                     justifyContent: 'center',
//                     zIndex: 999999,
//                     transition: 'opacity 0.4s ease',
//                     fontFamily: 'Arial, sans-serif',
//                     opacity: fadeOut ? 0 : 1,
//                     pointerEvents: fadeOut ? 'none' : 'auto'
//                 }}>
//                     <div style={{ textAlign: 'center' }}>
//                         <div style={{
//                             fontSize: '2rem',
//                             fontWeight: 900,
//                             letterSpacing: '6px',
//                             marginBottom: '30px',
//                         }}>
//                             {"MAAMAAS".split("").map((l, i) => (
//                                 <span
//                                     key={i}
//                                     style={{
//                                         display: 'inline-block',
//                                         opacity: 0,
//                                         transform: 'translateY(30px)',
//                                         animation: `letterAnim 0.8s ease forwards ${i * 0.1}s`,
//                                         color: '#e50914',
//                                     }}
//                                 >
//                                     {l}
//                                 </span>
//                             ))}
//                         </div>

//                         <div style={{
//                             width: '280px',
//                             height: '4px',
//                             background: 'rgba(255,255,255,0.2)',
//                             overflow: 'hidden',
//                             margin: '0 auto',
//                         }}>
//                             <div style={{
//                                 width: '40%',
//                                 height: '100%',
//                                 background: 'linear-gradient(90deg,#e50914,#ff6b6b)',
//                                 animation: 'progress 1.8s infinite',
//                             }}></div>
//                         </div>

//                         <div style={{
//                             marginTop: '20px',
//                             color: '#aaa',
//                             fontSize: '14px',
//                         }}>
//                             Loading user data...
//                         </div>
//                     </div>
//                 </div>
//             )}

//             <div className="row g-0" style={{ marginTop: '90px', height: "92vh" }}>
//                 {/* <div className="col-lg-2"></div> */}
//                 <div className="col-lg-12">


//                     {/* Tab Buttons Container - Fixed position */}
//                     {/* Tab Buttons Container - Fixed position */}
//                     <div className="sticky-top py-1 px-1" style={{ top: '66px' }}>
//                         <div className="row g-2 justify-content-start">
//                             {Object.keys(tabContent).map((label) => (
//                                 <div className="col-auto" style={{ minWidth: '100px' }} key={label}>
//                                     <button
//                                         onClick={() => setActiveTab(label)}
//                                         style={{
//                                             border: "none",
//                                             borderRadius: "10px",
//                                             minWidth: "140px",
//                                             width: "100%",
//                                             padding: "0 10px",
//                                             height: "40px",
//                                             backgroundColor: activeTab === label ? "rgb(230 109 51)" : "#d9d9d9",
//                                             color: activeTab === label ? "#fff" : "#000",
//                                             fontWeight: "bold",
//                                             cursor: "pointer",
//                                             transition: "background-color 0.3s ease",
//                                             fontSize: "1rem",
//                                         }}
//                                     >
//                                         {label}
//                                     </button>
//                                 </div>
//                             ))}
//                         </div>
//                     </div>

//                     {/* Tab Content Container - Scrollable area */}
//                     <div
//                         style={{
//                             height: `calc(100vh - 75px - 60px)`,
//                             overflowY: "auto",
//                             scrollbarWidth: "none",
//                             padding: "10px",
//                         }}
//                         className=""
//                     >
//                         <style>{`
//               div::-webkit-scrollbar { 
//                 display: none; 
//               }
//             `}</style>
//                         {tabContent[activeTab]}
//                     </div>
//                 </div>
//             </div>

//             {/* Add loader animations to existing style */}


//             <style>{`
//                 @keyframes letterAnim {
//                     0% { opacity: 0; transform: translateY(30px); }
//                     100% { opacity: 1; transform: translateY(0); }
//                 }

//                 @keyframes progress {
//                     0% { transform: translateX(-100%); }
//                     100% { transform: translateX(250%); }
//                 }
//             `}</style>
//         </div>
//     );
// };

// // User Tab Component with side-by-side dropdown and search Componenet Modules Of the Subscription Userdetails 
// const UserTabContent = ({
//     data,
//     selectedStatusFilter,
//     setSelectedStatusFilter,
//     selectedCategoryFilter,
//     setSelectedCategoryFilter,
//     filteredData
// }) => {
//     const [searchType, setSearchType] = useState("userId"); // Default search type
//     const [searchQuery, setSearchQuery] = useState("");
//     const [selectedCustomer, setSelectedCustomer] = useState(null);
//     const [loadingProfile, setLoadingProfile] = useState(false);
//     const [selectedDate, setSelectedDate] = useState("");
//     // Use inline loader for user profile loading
//     const { showLoader: showProfileLoader, hideLoader: hideProfileLoader, loading: profileLoading, fadeOut: profileFadeOut } = useInlineLoader();

//     // Search options for dropdown
//     const searchOptions = [
//         { value: "userId", label: "User ID" },
//         { value: "userName", label: "User Name" },
//         { value: "email", label: "Email" },
//         { value: "mobileNumber", label: "Mobile Number" }
//     ];

//     // Field mapping for search types to actual data fields
//     const fieldMapping = {
//         userId: 'userId',
//         userName: 'userName',
//         email: 'emailId',  // Map 'email' search type to 'emailId' field
//         mobileNumber: 'mobileNumber'
//     };

//     const formatDate = (dateValue) => {
//         if (!dateValue) return "-";
//         const date = new Date(dateValue);

//         const day = String(date.getDate()).padStart(2, "0");
//         const month = String(date.getMonth() + 1).padStart(2, "0");
//         const year = date.getFullYear();

//         return `${day}/${month}/${year}`;
//     };

//     const formatTime = (dateValue) => {
//         if (!dateValue) return "-";
//         const date = new Date(dateValue);

//         const hours = String(date.getHours()).padStart(2, "0");
//         const minutes = String(date.getMinutes()).padStart(2, "0");
//         const seconds = String(date.getSeconds()).padStart(2, "0");

//         return `${hours}:${minutes}:${seconds}`;
//     };

//     // Filter data based on selected search type and query - FIXED VERSION
//     const searchFilteredData = useMemo(() => {
//         let result = filteredData;

//         // Search Filter
//         if (searchQuery.trim()) {
//             const query = searchQuery.toLowerCase().trim();

//             result = result.filter((user) => {
//                 const actualField = fieldMapping[searchType];
//                 const fieldValue = user[actualField];

//                 if (!fieldValue) return false;

//                 if (searchType === "mobileNumber") {
//                     const cleanUserMobile = fieldValue.toString().replace(/\D/g, "");
//                     const cleanQuery = query.replace(/\D/g, "");

//                     return (
//                         fieldValue.toString().toLowerCase().includes(query) ||
//                         cleanUserMobile.includes(cleanQuery)
//                     );
//                 }

//                 return fieldValue.toString().toLowerCase().includes(query);
//             });
//         }

//         // Date Filter
//         if (selectedDate) {
//             result = result.filter((user) => {
//                 if (!user.registeredTime) return false;

//                 const userDate = new Date(user.registeredTime)
//                     .toISOString()
//                     .split("T")[0];

//                 return userDate === selectedDate;
//             });
//         }

//         return result;
//     }, [filteredData, searchType, searchQuery, selectedDate]);

//     // Fixed export function
//     const handleExportFiltered = () => {
//         // Use searchFilteredData instead of data
//         const exportData = searchFilteredData.length > 0 ? searchFilteredData : filteredData;

//         if (exportData.length === 0) {
//             alert("There is no data to export.");
//             return;
//         }

//         const escapeCsvField = (field) => {
//             const str = String(field ?? '');
//             if (str.includes(',') || str.includes('"') || str.includes('\n')) {
//                 return `"${str.replace(/"/g, '""')}"`;
//             }
//             return str;
//         };

//         const headers = [
//             "S.NO",
//             "Customer ID",
//             "Name",
//             "Email",
//             "Phone Number",
//             "Status"
//         ];

//         // Map the filtered data for export
//         const csvRows = exportData.map((user, index) => [
//             index + 1,
//             user.userId || 'N/A',
//             user.userName || 'N/A',
//             user.emailId || 'N/A',
//             user.mobileNumber || 'N/A',
//             user.active ? "Active" : "Inactive"
//         ]);

//         const csvString = [
//             headers.map(escapeCsvField).join(','),
//             ...csvRows.map(row => row.map(escapeCsvField).join(','))
//         ].join('\r\n');

//         const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
//         const url = URL.createObjectURL(blob);
//         const link = document.createElement("a");
//         link.setAttribute("href", url);
//         link.setAttribute("download", "filtered_users.csv");
//         document.body.appendChild(link);
//         link.click();
//         document.body.removeChild(link);
//         URL.revokeObjectURL(url);
//     };

//     // Clear all search filters
//     const clearAllFilters = () => {
//         setSearchQuery("");
//         setSelectedStatusFilter("");
//         setSelectedCategoryFilter("");
//         setSelectedDate("");
//     };

//     // Get placeholder text based on search type
//     const getPlaceholderText = () => {
//         switch (searchType) {
//             case "userId": return "Search User ID";
//             case "userName": return "Search Name";
//             case "email": return "Search Email";
//             case "mobileNumber": return "Search Mobile";
//             default: return "Search...";
//         }
//     };

//     const fetchUserProfileById =
//         async (userId) => {

//             setLoadingProfile(true);

//             showProfileLoader();

//             try {
//                 const data =
//                     await getUserProfileByIdAPI(
//                         userId
//                     );

//                 setSelectedCustomer(data);

//             } catch (error) {
//                 console.error(
//                     "Error fetching user profile:",
//                     error
//                 );

//                 alert(
//                     "Unable to fetch user details"
//                 );

//             } finally {
//                 setLoadingProfile(false);

//                 hideProfileLoader();
//             }
//         };

//     return (
//         <div className="user-management-container" style={{ marginTop: '0px' }}>
//             {/* Profile Loading Loader */}
//             {profileLoading && (
//                 <div style={{
//                     position: 'fixed',
//                     top: 0,
//                     left: 0,
//                     right: 0,
//                     bottom: 0,
//                     background: 'rgba(0,0,0,0.95)',
//                     display: 'flex',
//                     alignItems: 'center',
//                     justifyContent: 'center',
//                     zIndex: 999998,
//                     transition: 'opacity 0.4s ease',
//                     fontFamily: 'Arial, sans-serif',
//                     opacity: profileFadeOut ? 0 : 1,
//                     pointerEvents: profileFadeOut ? 'none' : 'auto'
//                 }}>
//                     <div style={{ textAlign: 'center' }}>
//                         <div style={{
//                             fontSize: '2rem',
//                             fontWeight: 900,
//                             letterSpacing: '6px',
//                             marginBottom: '30px',
//                         }}>
//                             {"MAAMAAS".split("").map((l, i) => (
//                                 <span
//                                     key={i}
//                                     style={{
//                                         display: 'inline-block',
//                                         opacity: 0,
//                                         transform: 'translateY(30px)',
//                                         animation: `letterAnim 0.8s ease forwards ${i * 0.1}s`,
//                                         color: '#e50914',
//                                     }}
//                                 >
//                                     {l}
//                                 </span>
//                             ))}
//                         </div>

//                         <div style={{
//                             width: '280px',
//                             height: '4px',
//                             background: 'rgba(255,255,255,0.2)',
//                             overflow: 'hidden',
//                             margin: '0 auto',
//                         }}>
//                             <div style={{
//                                 width: '40%',
//                                 height: '100%',
//                                 background: 'linear-gradient(90deg,#e50914,#ff6b6b)',
//                                 animation: 'progress 1.8s infinite',
//                             }}></div>
//                         </div>

//                         <div style={{
//                             marginTop: '20px',
//                             color: '#aaa',
//                             fontSize: '14px',
//                         }}>
//                             Loading user profile...
//                         </div>
//                     </div>
//                 </div>
//             )}

//             <div className="row g-2 mb-1 align-items-center me-0">
//                 {/* Search Type Dropdown and Search Input - Side by Side */}
//                 <div className="col-md-auto col-12">
//                     <div className="d-flex align-items-center" style={{ gap: '10px' }}>
//                         {/* Search Type Dropdown */}
//                         <div style={{ minWidth: '150px' }}>
//                             <select
//                                 className="form-select"
//                                 value={searchType}
//                                 onChange={(e) => setSearchType(e.target.value)}
//                                 style={{ height: "40px" }}
//                             >
//                                 {searchOptions.map(option => (
//                                     <option key={option.value} value={option.value}>
//                                         {option.label}
//                                     </option>
//                                 ))}
//                             </select>
//                         </div>

//                         {/* Search Input */}
//                         <div style={{ minWidth: '200px' }}>
//                             <input
//                                 type="text"
//                                 className="form-control"
//                                 placeholder={getPlaceholderText()}
//                                 value={searchQuery}
//                                 onChange={(e) => setSearchQuery(e.target.value)}
//                                 style={{ height: "40px" }}
//                             />
//                         </div>

//                         {/* Date Filter */}
//                         <div className="col-md-auto col-12">
//                             <input
//                                 type="date"
//                                 className="form-control"
//                                 value={selectedDate}
//                                 onChange={(e) => setSelectedDate(e.target.value)}
//                                 style={{
//                                     height: "40px",
//                                     minWidth: "180px"
//                                 }}
//                             />
//                         </div>
//                     </div>
//                 </div>

//                 {/* Status Filter */}
//                 <div className="col-md-auto col-12">
//                     <select
//                         className="form-select"
//                         value={selectedStatusFilter}
//                         onChange={(e) => setSelectedStatusFilter(e.target.value)}
//                         aria-label="Filter by status"
//                         style={{ maxWidth: '150px', height: "40px" }}
//                     >
//                         <option value="">All Status</option>
//                         <option value="true">Active</option>
//                         <option value="false">Inactive</option>
//                     </select>
//                 </div>

//                 {/* Clear Filters Button */}
//                 <div className="col-md-auto col-12">
//                     <button
//                         className="btn"
//                         onClick={clearAllFilters}
//                         style={{
//                             backgroundColor: '#6c757d',
//                             color: '#fff',
//                             height: "40px",
//                             padding: "0 15px"
//                         }}
//                     >
//                         Clear Filters
//                     </button>
//                 </div>

//                 {/* Export Button */}
//                 <div className="col-md col-12">
//                     <div className="d-flex justify-content-start justify-content-md-end">
//                         <button
//                             className="btn"
//                             onClick={handleExportFiltered}
//                             style={{
//                                 backgroundColor: 'rgb(230 109 51)',
//                                 color: '#fff',
//                                 height: "40px",
//                                 padding: "0 20px"
//                             }}
//                         >
//                             Export
//                         </button>
//                     </div>
//                 </div>
//             </div>

//             {/* Users Table with Fixed Headers */}
//             <div className="user-table-container" style={{
//                 marginTop: '10px',
//                 border: '1px solid #ddd',
//                 borderRadius: '4px',
//                 overflow: 'hidden'
//             }}>
//                 {/* Fixed Header Table */}
//                 <div style={{
//                     overflow: 'hidden',
//                     backgroundColor: '#fff'
//                 }}>
//                     <table style={{
//                         width: "100%",
//                         fontSize: "0.95rem",
//                         borderCollapse: "collapse",
//                         tableLayout: 'fixed' // Fixed layout for better column alignment
//                     }}>
//                         <thead>
//                             <tr>
//                                 <th style={{ ...tableHeaderStyle, width: '50px' }}>S.NO</th>
//                                 <th style={{ ...tableHeaderStyle, width: '80px' }}>Date</th>
//                                 <th style={{ ...tableHeaderStyle, width: '80px' }}>Time</th>
//                                 <th style={{ ...tableHeaderStyle, width: '100px' }}>Name</th>
//                                 <th style={{ ...tableHeaderStyle, width: '100px' }}>User ID</th>
//                                 <th style={{ ...tableHeaderStyle, width: '150px' }}>Email</th>
//                                 <th style={{ ...tableHeaderStyle, width: '100px' }}>Phone Number</th>
//                                 <th style={{ ...tableHeaderStyle, width: '90px' }}>User Type</th>
//                                 <th style={{ ...tableHeaderStyle, width: '70px' }}>Status</th>
//                                 <th style={{ ...tableHeaderStyle, width: '70px' }}>View</th>
//                             </tr>
//                         </thead>
//                     </table>
//                 </div>

//                 {/* Scrollable Body Table */}
//                 <div style={{
//                     maxHeight: "450px",
//                     overflowY: "auto",
//                     overflowX: 'hidden'
//                 }}>
//                     <table style={{
//                         width: "100%",
//                         fontSize: "0.95rem",
//                         borderCollapse: "collapse",
//                         tableLayout: 'fixed' // Same fixed layout as header
//                     }}>
//                         <tbody>
//                             {searchFilteredData.length > 0 ? (
//                                 searchFilteredData.map((user, index) => (
//                                     <tr
//                                         key={user.userId || index}
//                                         style={{ backgroundColor: index % 2 === 0 ? "#f9f9f9" : "#ffffff" }}
//                                     >
//                                         <td style={{ ...tableCellStyle, width: '50px' }}>{index + 1}</td>

//                                         {/* DATE */}
//                                         <td style={{ ...tableCellStyle, width: '80px' }}>
//                                             {formatDate(user.registeredTime)}
//                                         </td>

//                                         {/* TIME */}
//                                         <td style={{ ...tableCellStyle, width: '80px' }}>
//                                             {formatTime(user.registeredTime)}
//                                         </td>

//                                         <td style={{ ...tableCellStyle, width: '100px' }}>{user.userName}</td>
//                                         <td style={{ ...tableCellStyle, width: '100px' }}>{user.userId}</td>
//                                         <td style={{ ...tableCellStyle, width: '150px' }}>{user.emailId}</td>
//                                         <td style={{ ...tableCellStyle, width: '100px' }}>{user.mobileNumber}</td>
//                                         <td style={{ ...tableCellStyle, width: '90px' }}>{user.userType}</td>
//                                         <td style={{ ...tableCellStyle, width: '70px' }}>
//                                             {user.active ? "Active" : "Inactive"}
//                                         </td>
//                                         <td style={{ ...tableCellStyle, width: '70px' }}>
//                                             <button style={viewBtn} onClick={() => fetchUserProfileById(user.userId)}>View</button>
//                                         </td>
//                                     </tr>
//                                 ))
//                             ) : (
//                                 <tr>
//                                     <td colSpan="10" style={noDataStyle}>
//                                         {data.length === 0
//                                             ? "Loading data or no users found."
//                                             : (searchQuery.trim() || selectedStatusFilter || selectedCategoryFilter)
//                                                 ? "No users found with the specified filters."
//                                                 : "No users match the current filters."}
//                                     </td>
//                                 </tr>
//                             )}
//                         </tbody>
//                     </table>
//                 </div>
//             </div>

//             {selectedCustomer && (
//                 <div style={overlay}>
//                     <div style={modal}>
//                         <h4>User Details</h4>
//                         <hr />

//                         {loadingProfile ? (
//                             <p>Loading user details...</p>
//                         ) : (
//                             <>
//                                 <p><b>Name:</b> {selectedCustomer.userName || "-"}</p>
//                                 <p><b>Email:</b> {selectedCustomer.emailId || "-"}</p>
//                                 <p><b>Mobile:</b> {selectedCustomer.mobileNumber || "-"}</p>

//                                 <p><b>Referral Code:</b> {selectedCustomer.referralCode || "-"}</p>
//                                 <p><b>Total Referrals:</b> {selectedCustomer.totalReferals ?? 0}</p>
//                                 <p><b>Total Cashback:</b> ₹{selectedCustomer.totalCashBack ?? 0}</p>

//                                 {/* Optional Image */}
//                                 {selectedCustomer.image && (
//                                     <div style={{ marginTop: "10px" }}>
//                                         <b>Profile Image:</b><br />
//                                         <img
//                                             src={selectedCustomer.image}
//                                             alt="Profile"
//                                             style={{ width: "80px", height: "80px", borderRadius: "50%" }}
//                                         />
//                                     </div>
//                                 )}
//                             </>
//                         )}

//                         <div style={{ textAlign: "right", marginTop: "15px" }}>
//                             <button
//                                 style={closeBtn}
//                                 onClick={() => setSelectedCustomer(null)}
//                             >
//                                 Close
//                             </button>
//                         </div>
//                     </div>
//                 </div>
//             )}
//         </div>
//     );
// };

// // Professional User Tab Component (Already imported)
// // Post Paid Users Tab Component (Already imported)
// const tableHeaderStyle = {
//     border: "1px solid #ddd",
//     textAlign: "center",
//     fontWeight: "bold",
//     backgroundColor: "rgb(230 109 51)",
//     color: "white",
//     padding: "6px",
// };

// const tableCellStyle = {
//     border: "1px solid #ddd",
//     textAlign: "center",
//     padding: "6px",
// };

// const viewBtn = {
//     background: "rgb(230 109 51)",
//     color: "#fff",
//     border: "none",
//     padding: "4px 12px",
//     borderRadius: "6px",
//     cursor: "pointer",
// };

// const closeBtn = {
//     background: "#dc3545",
//     color: "#fff",
//     border: "none",
//     padding: "6px 16px",
//     borderRadius: "6px",
// };

// const overlay = {
//     position: "fixed",
//     top: 0,
//     left: 0,
//     width: "100%",
//     height: "100%",
//     background: "rgba(0,0,0,0.5)",
//     display: "flex",
//     justifyContent: "center",
//     alignItems: "center",
//     zIndex: 10000,
// };

// const modal = {
//     background: "#fff",
//     padding: "20px",
//     borderRadius: "10px",
//     width: "400px",
// };
// const noDataStyle = {
//     fontStyle: "italic",
//     textAlign: "center",
//     padding: "10px",
//     color: "#888",
// };

// export default Userdetails;






// Userdetails.js
import React, { useEffect, useState, useMemo } from "react";
import "./Usermanagement.css";
import { Link } from "react-router-dom";
import ProfessionalUser from "./ProfessionalUser";
import PostPaidUsers from "./PostPaidUsers";
import {
    getAllUsers,
    getUserProfileByIdAPI,
} from "../../../Servicefile/userservicefile.jsx";

// Inline loader hook
const useInlineLoader = () => {
    const [loading, setLoading] = useState(false);
    const [fadeOut, setFadeOut] = useState(false);

    const showLoader = () => {
        setFadeOut(false);
        setLoading(true);
    };

    const hideLoader = () => {
        setFadeOut(true);
        setTimeout(() => {
            setLoading(false);
            setFadeOut(false);
        }, 500);
    };

    return { showLoader, hideLoader, loading, fadeOut };
};

const Userdetails = () => {
    const [selectedCustomer, setSelectedCustomer] = useState(null);
    const [data, setData] = useState([]);
    const [screenWidth, setScreenWidth] = useState(window.innerWidth);
    const [selectedStatusFilter, setSelectedStatusFilter] = useState("");
    const [selectedCategoryFilter, setSelectedCategoryFilter] = useState("");
    const [activeTab, setActiveTab] = useState("User");
    const [searchType, setSearchType] = useState("userId");
    const [searchQuery, setSearchQuery] = useState("");
    const [selectedDate, setSelectedDate] = useState("");

    const { showLoader, hideLoader, loading: globalLoading, fadeOut } = useInlineLoader();

    const filteredData = useMemo(() => {
        return data.filter(user => {
            const statusMatch = !selectedStatusFilter ||
                user.active === (selectedStatusFilter === "true");
            const categoryMatch = !selectedCategoryFilter ||
                (user.category && user.category.toLowerCase() === selectedCategoryFilter.toLowerCase());
            return statusMatch && categoryMatch;
        });
    }, [data, selectedStatusFilter, selectedCategoryFilter]);

    const searchFilteredData = useMemo(() => {
        let result = filteredData;

        if (searchQuery.trim()) {
            const query = searchQuery.toLowerCase().trim();
            result = result.filter((user) => {
                const actualField = fieldMapping[searchType];
                const fieldValue = user[actualField];
                if (!fieldValue) return false;
                if (searchType === "mobileNumber") {
                    const cleanUserMobile = fieldValue.toString().replace(/\D/g, "");
                    const cleanQuery = query.replace(/\D/g, "");
                    return fieldValue.toString().toLowerCase().includes(query) ||
                        cleanUserMobile.includes(cleanQuery);
                }
                return fieldValue.toString().toLowerCase().includes(query);
            });
        }

        if (selectedDate) {
            result = result.filter((user) => {
                if (!user.registeredTime) return false;
                const userDate = new Date(user.registeredTime).toISOString().split("T")[0];
                return userDate === selectedDate;
            });
        }

        return result;
    }, [filteredData, searchType, searchQuery, selectedDate]);

    const fieldMapping = {
        userId: "userId",
        userName: "userName",
        email: "emailId",
        mobileNumber: "mobileNumber",
    };

    const tabContent = {
        "User": <UserTabContent
            data={data}
            selectedStatusFilter={selectedStatusFilter}
            setSelectedStatusFilter={setSelectedStatusFilter}
            selectedCategoryFilter={selectedCategoryFilter}
            setSelectedCategoryFilter={setSelectedCategoryFilter}
            filteredData={filteredData}
        />,
        "Enterprise User": <ProfessionalUser />,
    };

    useEffect(() => {
        const handleResize = () => setScreenWidth(window.innerWidth);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    useEffect(() => {
        const controller = new AbortController();
        const authToken = localStorage.getItem("authToken");

        const fetchUsers = async () => {
            try {
                showLoader();
                const fetchedData = await getAllUsers(authToken);
                const personalUsers = fetchedData.filter(item => item.userType === "PERSONAL");
                const dataWithSno = personalUsers.map((item, index) => ({
                    ...item,
                    sno: index + 1,
                    category: item.category || "N/A",
                    subscription: item.subscription || "N/A",
                    orders: typeof item.orders === "number" ? item.orders : 0,
                    last: item.lastOrderDate || item.last || "N/A",
                    statusAsDeliveryAgent: item.status || item.statusAsDeliveryAgent || "N/A",
                }));
                setData(dataWithSno);
            } catch (err) {
                if (err.name !== "AbortError") {
                    console.error("Error fetching users:", err);
                }
            } finally {
                hideLoader();
            }
        };

        fetchUsers();
        return () => controller.abort();
    }, []);

    return (
        <div className="user-management-wrapper">
            {/* Global Loader */}
            {globalLoading && (
                <div className="global-loader-overlay" style={{
                    opacity: fadeOut ? 0 : 1,
                    pointerEvents: fadeOut ? 'none' : 'auto'
                }}>
                    <div className="loader-content">
                        <div className="loader-brand">
                            {"MAAMAAS".split("").map((l, i) => (
                                <span
                                    key={i}
                                    className="loader-letter"
                                    style={{ animationDelay: `${i * 0.1}s` }}
                                >
                                    {l}
                                </span>
                            ))}
                        </div>
                        <div className="loader-progress-bar">
                            <div className="loader-progress-fill"></div>
                        </div>
                        <div className="loader-text">Loading user data...</div>
                    </div>
                </div>
            )}

            <div className="user-management-layout">
                <div className="user-management-content">
                    {/* Tab Navigation */}
                    <div className="tab-navigation">
                        <div className="tab-container">
                            {Object.keys(tabContent).map((label) => (
                                <button
                                    key={label}
                                    onClick={() => setActiveTab(label)}
                                    className={`tab-button ${activeTab === label ? 'active' : ''}`}
                                >
                                    {label}
                                </button>
                            ))}
                        </div>
                    </div>

                    {/* Tab Content */}
                    <div className="tab-content-container">
                        {tabContent[activeTab]}
                    </div>
                </div>
            </div>

            <style>{`
                @keyframes letterAnim {
                    0% { opacity: 0; transform: translateY(30px); }
                    100% { opacity: 1; transform: translateY(0); }
                }
                @keyframes progress {
                    0% { transform: translateX(-100%); }
                    100% { transform: translateX(250%); }
                }
                .global-loader-overlay {
                    position: fixed;
                    top: 0;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    background: rgba(0,0,0,0.95);
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    z-index: 999999;
                    transition: opacity 0.4s ease;
                }
                .loader-content {
                    text-align: center;
                }
                .loader-brand {
                    font-size: 2.5rem;
                    font-weight: 900;
                    letter-spacing: 6px;
                    margin-bottom: 30px;
                }
                .loader-letter {
                    display: inline-block;
                    opacity: 0;
                    transform: translateY(30px);
                    animation: letterAnim 0.8s ease forwards;
                    color: #e50914;
                }
                .loader-progress-bar {
                    width: 280px;
                    height: 4px;
                    background: rgba(255,255,255,0.2);
                    overflow: hidden;
                    margin: 0 auto;
                }
                .loader-progress-fill {
                    width: 40%;
                    height: 100%;
                    background: linear-gradient(90deg, #e50914, #ff6b6b);
                    animation: progress 1.8s infinite;
                }
                .loader-text {
                    margin-top: 20px;
                    color: #aaa;
                    font-size: 14px;
                }
                .user-management-wrapper {
                     padding: 10px;
                    // background: #f5f7fa;
                    min-height: 100vh;
                    margin-top:70px;
                }
                .user-management-layout {
                    max-width: 1400px;
                    margin: 0 auto;
                }
                .user-management-content {
                    
                    overflow: hidden;
                    scrollbar-width:none;
                }
                .tab-navigation {
                    // padding: 20px 20px 0 20px;
                    background: white;
                    // border-bottom: 2px solid #f0f0f0;
                }
                .tab-container {
                    display: flex;
                    gap: 8px;
                    flex-wrap: wrap;
                }
                .tab-button {
                    border: none;
                    border-radius: 12px;
                    padding: 12px 32px;
                    background: transparent;
                    color: #666;
                    font-weight: 600;
                    font-size: 1rem;
                    cursor: pointer;
                    transition: all 0.3s ease;
                    position: relative;
                }
                .tab-button:hover {
                    background: #f8f9fa;
                    color: #333;
                }
                .tab-button.active {
                    background: #e66d33;
                    color: white;
                    box-shadow: 0 4px 15px rgba(230, 109, 51, 0.3);
                }
                .tab-content-container {
                    padding: 2px;
                    // max-height: calc(100vh - 200px);
                    overflow-y: auto;
                }
                .tab-content-container::-webkit-scrollbar {
                    width: 6px;
                }
                .tab-content-container::-webkit-scrollbar-track {
                    background: #f1f1f1;
                    border-radius: 10px;
                }
                .tab-content-container::-webkit-scrollbar-thumb {
                    background: #c1c1c1;
                    border-radius: 10px;
                }
                .tab-content-container::-webkit-scrollbar-thumb:hover {
                    background: #a8a8a8;
                }
                @media (max-width: 768px) {
                    .user-management-wrapper {
                        padding: 10px;
                    }
                    .tab-button {
                        padding: 10px 20px;
                        font-size: 0.9rem;
                        flex: 1;
                        text-align: center;
                        min-width: 100px;
                    }
                    .tab-navigation {
                        padding: 15px 15px 0 15px;
                    }
                    .tab-content-container {
                        padding: 15px;
                        max-height: calc(100vh - 180px);
                    }
                }
                @media (max-width: 480px) {
                    .tab-button {
                        padding: 8px 14px;
                        font-size: 0.8rem;
                        min-width: 80px;
                    }
                    .loader-brand {
                        font-size: 1.8rem;
                        letter-spacing: 4px;
                    }
                    .loader-progress-bar {
                        width: 200px;
                    }
                }
            `}</style>
        </div>
    );
};

// User Tab Component
const UserTabContent = ({
    data,
    selectedStatusFilter,
    setSelectedStatusFilter,
    selectedCategoryFilter,
    setSelectedCategoryFilter,
    filteredData
}) => {
    const [searchType, setSearchType] = useState("userId");
    const [searchQuery, setSearchQuery] = useState("");
    const [selectedCustomer, setSelectedCustomer] = useState(null);
    const [loadingProfile, setLoadingProfile] = useState(false);
    const [selectedDate, setSelectedDate] = useState("");
    const { showLoader: showProfileLoader, hideLoader: hideProfileLoader, loading: profileLoading, fadeOut: profileFadeOut } = useInlineLoader();

    const searchOptions = [
        { value: "userId", label: "User ID" },
        { value: "userName", label: "User Name" },
        { value: "email", label: "Email" },
        { value: "mobileNumber", label: "Mobile Number" }
    ];

    const fieldMapping = {
        userId: 'userId',
        userName: 'userName',
        email: 'emailId',
        mobileNumber: 'mobileNumber'
    };

    const formatDate = (dateValue) => {
        if (!dateValue) return "-";
        const date = new Date(dateValue);
        return `${String(date.getDate()).padStart(2, "0")}/${String(date.getMonth() + 1).padStart(2, "0")}/${date.getFullYear()}`;
    };

    const formatTime = (dateValue) => {
        if (!dateValue) return "-";
        const date = new Date(dateValue);
        return `${String(date.getHours()).padStart(2, "0")}:${String(date.getMinutes()).padStart(2, "0")}:${String(date.getSeconds()).padStart(2, "0")}`;
    };

    const searchFilteredData = useMemo(() => {
        let result = filteredData;
        if (searchQuery.trim()) {
            const query = searchQuery.toLowerCase().trim();
            result = result.filter((user) => {
                const actualField = fieldMapping[searchType];
                const fieldValue = user[actualField];
                if (!fieldValue) return false;
                if (searchType === "mobileNumber") {
                    const cleanUserMobile = fieldValue.toString().replace(/\D/g, "");
                    const cleanQuery = query.replace(/\D/g, "");
                    return fieldValue.toString().toLowerCase().includes(query) || cleanUserMobile.includes(cleanQuery);
                }
                return fieldValue.toString().toLowerCase().includes(query);
            });
        }
        if (selectedDate) {
            result = result.filter((user) => {
                if (!user.registeredTime) return false;
                const userDate = new Date(user.registeredTime).toISOString().split("T")[0];
                return userDate === selectedDate;
            });
        }
        return result;
    }, [filteredData, searchType, searchQuery, selectedDate]);

    const handleExportFiltered = () => {
        const exportData = searchFilteredData.length > 0 ? searchFilteredData : filteredData;
        if (exportData.length === 0) {
            alert("There is no data to export.");
            return;
        }

        const escapeCsvField = (field) => {
            const str = String(field ?? '');
            if (str.includes(',') || str.includes('"') || str.includes('\n')) {
                return `"${str.replace(/"/g, '""')}"`;
            }
            return str;
        };

        const headers = ["S.NO", "Customer ID", "Name", "Email", "Phone Number", "Status"];
        const csvRows = exportData.map((user, index) => [
            index + 1,
            user.userId || 'N/A',
            user.userName || 'N/A',
            user.emailId || 'N/A',
            user.mobileNumber || 'N/A',
            user.active ? "Active" : "Inactive"
        ]);

        const csvString = [
            headers.map(escapeCsvField).join(','),
            ...csvRows.map(row => row.map(escapeCsvField).join(','))
        ].join('\r\n');

        const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.setAttribute("href", url);
        link.setAttribute("download", "filtered_users.csv");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    };

    const clearAllFilters = () => {
        setSearchQuery("");
        setSelectedStatusFilter("");
        setSelectedCategoryFilter("");
        setSelectedDate("");
    };

    const getPlaceholderText = () => {
        switch (searchType) {
            case "userId": return "Search by User ID...";
            case "userName": return "Search by Name...";
            case "email": return "Search by Email...";
            case "mobileNumber": return "Search by Mobile...";
            default: return "Search...";
        }
    };

    const fetchUserProfileById = async (userId) => {
        setLoadingProfile(true);
        showProfileLoader();
        try {
            const data = await getUserProfileByIdAPI(userId);
            setSelectedCustomer(data);
        } catch (error) {
            console.error("Error fetching user profile:", error);
            alert("Unable to fetch user details");
        } finally {
            setLoadingProfile(false);
            hideProfileLoader();
        }
    };

    return (
        <div className="user-tab-container">
            {/* Profile Loader */}
            {profileLoading && (
                <div className="profile-loader-overlay" style={{
                    opacity: profileFadeOut ? 0 : 1,
                    pointerEvents: profileFadeOut ? 'none' : 'auto'
                }}>
                    <div className="loader-content">
                        <div className="loader-brand">
                            {"MAAMAAS".split("").map((l, i) => (
                                <span key={i} className="loader-letter" style={{ animationDelay: `${i * 0.1}s` }}>
                                    {l}
                                </span>
                            ))}
                        </div>
                        <div className="loader-progress-bar">
                            <div className="loader-progress-fill"></div>
                        </div>
                        <div className="loader-text">Loading user profile...</div>
                    </div>
                </div>
            )}

            {/* Filters Section */}
            <div className="filters-section">
                <div className="filters-row">
                    <div className="filter-group">
                        <div className="search-group">
                            <select
                                className="search-select"
                                value={searchType}
                                onChange={(e) => setSearchType(e.target.value)}
                            >
                                {searchOptions.map(option => (
                                    <option key={option.value} value={option.value}>
                                        {option.label}
                                    </option>
                                ))}
                            </select>
                            <input
                                type="text"
                                className="search-input"
                                placeholder={getPlaceholderText()}
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                            />
                        </div>

                        <input
                            type="date"
                            className="date-input"
                            value={selectedDate}
                            onChange={(e) => setSelectedDate(e.target.value)}
                        />

                        <select
                            className="status-select"
                            value={selectedStatusFilter}
                            onChange={(e) => setSelectedStatusFilter(e.target.value)}
                        >
                            <option value="">All Status</option>
                            <option value="true">Active</option>
                            <option value="false">Inactive</option>
                        </select>
                    </div>

                    <div className="action-group">
                        <button className="btn-clear" onClick={clearAllFilters}>
                            Clear Filters
                        </button>
                        <button className="btn-export" onClick={handleExportFiltered}>
                            Export CSV
                        </button>
                    </div>
                </div>
            </div>

            {/* Table Section */}
            <div className="table-wrapper">
                <div className="table-header">
                    <table>
                        <thead>
                            <tr>
                                <th style={{ width: '4%' }}>#</th>
                                <th style={{ width: '8%' }}>Date</th>
                                <th style={{ width: '8%' }}>Time</th>
                                <th style={{ width: '12%' }}>Name</th>
                                <th style={{ width: '10%' }}>User ID</th>
                                <th style={{ width: '18%' }}>Email</th>
                                <th style={{ width: '12%' }}>Phone</th>
                                <th style={{ width: '10%' }}>Type</th>
                                <th style={{ width: '8%' }}>Status</th>
                                <th style={{ width: '6%' }}>View</th>
                            </tr>
                        </thead>
                    </table>
                </div>
                <div className="table-body">
                    <table>
                        <tbody>
                            {searchFilteredData.length > 0 ? (
                                searchFilteredData.map((user, index) => (
                                    <tr key={user.userId || index}>
                                        <td style={{ width: '4%' }}>{index + 1}</td>
                                        <td style={{ width: '8%' }}>{formatDate(user.registeredTime)}</td>
                                        <td style={{ width: '8%' }}>{formatTime(user.registeredTime)}</td>
                                        <td style={{ width: '12%' }}>{user.userName || '-'}</td>
                                        <td style={{ width: '10%' }}>{user.userId || '-'}</td>
                                        <td style={{ width: '18%' }}>{user.emailId || '-'}</td>
                                        <td style={{ width: '12%' }}>{user.mobileNumber || '-'}</td>
                                        <td style={{ width: '10%' }}>
                                            <span className="user-type-badge">
                                                {user.userType || '-'}
                                            </span>
                                        </td>
                                        <td style={{ width: '8%' }}>
                                            <span className={`status-badge ${user.active ? 'active' : 'inactive'}`}>
                                                {user.active ? 'Active' : 'Inactive'}
                                            </span>
                                        </td>
                                        <td style={{ width: '6%' }}>
                                            <button 
                                                className="btn-view"
                                                onClick={() => fetchUserProfileById(user.userId)}
                                            >
                                                View
                                            </button>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="10" className="no-data-cell">
                                        {data.length === 0
                                            ? "Loading data or no users found."
                                            : (searchQuery.trim() || selectedStatusFilter || selectedCategoryFilter)
                                                ? "No users found with the specified filters."
                                                : "No users match the current filters."}
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>

            {/* User Details Modal */}
            {selectedCustomer && (
                <div className="modal-overlayyz" onClick={() => setSelectedCustomer(null)}>
                    <div className="modal-contentyz" onClick={(e) => e.stopPropagation()}>
                        <div className="modal-header-custom">
                            <h4 className="modal-title">User Profile Details</h4>
                            <button className="modal-close-btn" onClick={() => setSelectedCustomer(null)}>
                                ×
                            </button>
                        </div>
                        <div className="modal-body-custom">
                            {loadingProfile ? (
                                <div className="modal-loading">Loading user details...</div>
                            ) : (
                                <div className="user-profile-details">
                                    <div className="profile-row">
                                        <div className="profile-label">Name</div>
                                        <div className="profile-value">{selectedCustomer.userName || "-"}</div>
                                    </div>
                                    <div className="profile-row">
                                        <div className="profile-label">Email</div>
                                        <div className="profile-value">{selectedCustomer.emailId || "-"}</div>
                                    </div>
                                    <div className="profile-row">
                                        <div className="profile-label">Mobile</div>
                                        <div className="profile-value">{selectedCustomer.mobileNumber || "-"}</div>
                                    </div>
                                    <div className="profile-row">
                                        <div className="profile-label">User ID</div>
                                        <div className="profile-value">{selectedCustomer.userId || "-"}</div>
                                    </div>
                                    <div className="profile-row">
                                        <div className="profile-label">User Type</div>
                                        <div className="profile-value">
                                            <span className="user-type-badge">{selectedCustomer.userType || "-"}</span>
                                        </div>
                                    </div>
                                    <div className="profile-row">
                                        <div className="profile-label">Status</div>
                                        <div className="profile-value">
                                            <span className={`status-badge ${selectedCustomer.active ? 'active' : 'inactive'}`}>
                                                {selectedCustomer.active ? 'Active' : 'Inactive'}
                                            </span>
                                        </div>
                                    </div>
                                    <div className="profile-row">
                                        <div className="profile-label">Referral Code</div>
                                        <div className="profile-value">{selectedCustomer.referralCode || "-"}</div>
                                    </div>
                                    <div className="profile-row">
                                        <div className="profile-label">Total Referrals</div>
                                        <div className="profile-value">{selectedCustomer.totalReferals ?? 0}</div>
                                    </div>
                                    <div className="profile-row">
                                        <div className="profile-label">Total Cashback</div>
                                        <div className="profile-value">₹{selectedCustomer.totalCashBack ?? 0}</div>
                                    </div>
                                    <div className="profile-row">
                                        <div className="profile-label">Registered On</div>
                                        <div className="profile-value">
                                            {selectedCustomer.registeredTime 
                                                ? formatDate(selectedCustomer.registeredTime) + ' at ' + formatTime(selectedCustomer.registeredTime)
                                                : "-"}
                                        </div>
                                    </div>
                                    {selectedCustomer.image && (
                                        <div className="profile-row">
                                            <div className="profile-label">Profile Image</div>
                                            <div className="profile-value">
                                                <img 
                                                    src={selectedCustomer.image} 
                                                    alt="Profile" 
                                                    className="profile-image"
                                                />
                                            </div>
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                        <div className="modal-footer-custom">
                            <button className="btn-close-modal" onClick={() => setSelectedCustomer(null)}>
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            )}

            <style>{`
                .user-tab-container {
                    padding: 10px 0;
                  
                }
                .filters-section {
                    margin-bottom: 20px;
                    background: white;
                    border-radius: 12px;
                    padding: 16px;
                    box-shadow: 0 2px 8px rgba(0,0,0,0.06);
                }
                .filters-row {
                    display: flex;
                    flex-wrap: wrap;
                    gap: 12px;
                    align-items: center;
                    justify-content: space-between;
                }
                .filter-group {
                    display: flex;
                    flex-wrap: wrap;
                    gap: 10px;
                    align-items: center;
                    flex: 1;
                }
                .search-group {
                    display: flex;
                    gap: 0;
                    align-items: center;
                    border: 1px solid #e0e0e0;
                    border-radius: 8px;
                    overflow: hidden;
                    flex: 1;
                    min-width: 250px;
                }
                .search-select {
                    border: none;
                    padding: 8px 12px;
                    background: #f8f9fa;
                    font-size: 0.9rem;
                    border-right: 1px solid #e0e0e0;
                    min-width: 120px;
                    cursor: pointer;
                    height: 40px;
                }
                .search-input {
                    border: none;
                    padding: 8px 12px;
                    font-size: 0.9rem;
                    flex: 1;
                    min-width: 150px;
                    height: 40px;
                }
                .search-input:focus {
                    outline: none;
                }
                .date-input {
                    padding: 8px 12px;
                    border: 1px solid #e0e0e0;
                    border-radius: 8px;
                    font-size: 0.9rem;
                    height: 40px;
                    min-width: 160px;
                }
                .status-select {
                    padding: 8px 12px;
                    border: 1px solid #e0e0e0;
                    border-radius: 8px;
                    font-size: 0.9rem;
                    height: 40px;
                    min-width: 140px;
                    background: white;
                    cursor: pointer;
                }
                .action-group {
                    display: flex;
                    gap: 10px;
                    align-items: center;
                }
                .btn-clear {
                    padding: 8px 18px;
                    border: none;
                    border-radius: 8px;
                    background: #6c757d;
                    color: white;
                    font-weight: 500;
                    cursor: pointer;
                    transition: all 0.3s ease;
                    height: 40px;
                }
                .btn-clear:hover {
                    background: #5a6268;
                    transform: translateY(-1px);
                    box-shadow: 0 4px 12px rgba(108,117,125,0.3);
                }
                .btn-export {
                    padding: 8px 20px;
                    border: none;
                    border-radius: 8px;
                    background: linear-gradient(135deg, #e66d33, #d45a2a);
                    color: white;
                    font-weight: 500;
                    cursor: pointer;
                    transition: all 0.3s ease;
                    height: 40px;
                }
                .btn-export:hover {
                    transform: translateY(-1px);
                    box-shadow: 0 4px 15px rgba(230,109,51,0.4);
                }
                .table-wrapper {
                    border: 1px solid #e8e8e8;
                    border-radius: 12px;
                    overflow: hidden;
                    background: white;
                    box-shadow: 0 2px 8px rgba(0,0,0,0.06);
                }
                .table-header {
                    overflow: hidden;
                    background: #f8f9fa;
                }
                .table-header table {
                    width: 100%;
                    border-collapse: collapse;
                }
                .table-header th {
                    padding: 12px 8px;
                    background: linear-gradient(135deg, #e66d33, #d45a2a);
                    color: white;
                    font-weight: 600;
                    font-size: 0.85rem;
                    text-transform: uppercase;
                    letter-spacing: 0.5px;
                    text-align: center;
                    white-space: nowrap;
                }
                .table-body {
                    max-height: 450px;
                    overflow-y: auto;
                }
                .table-body table {
                    width: 100%;
                    border-collapse: collapse;
                }
                .table-body td {
                    padding: 10px 8px;
                    font-size: 0.85rem;
                    text-align: center;
                    border-bottom: 1px solid #f0f0f0;
                    vertical-align: middle;
                }
                .table-body tr:nth-child(even) {
                    background: #fafbfc;
                }
                .table-body tr:hover {
                    background: #f0f4ff;
                }
                .user-type-badge {
                    display: inline-block;
                    padding: 2px 10px;
                    border-radius: 12px;
                    background: #e8f0fe;
                    color: #1a73e8;
                    font-size: 0.75rem;
                    font-weight: 500;
                }
                .status-badge {
                    display: inline-block;
                    padding: 2px 12px;
                    border-radius: 12px;
                    font-size: 0.75rem;
                    font-weight: 500;
                }
                .status-badge.active {
                    background: #d4edda;
                    color: #155724;
                }
                .status-badge.inactive {
                    background: #f8d7da;
                    color: #721c24;
                }
                .btn-view {
                    padding: 4px 14px;
                    border: none;
                    border-radius: 6px;
                    background: linear-gradient(135deg, #e66d33, #d45a2a);
                    color: white;
                    cursor: pointer;
                    font-size: 0.8rem;
                    transition: all 0.3s ease;
                }
                .btn-view:hover {
                    transform: scale(1.05);
                    box-shadow: 0 2px 10px rgba(230,109,51,0.3);
                }
                .no-data-cell {
                    padding: 30px !important;
                    text-align: center !important;
                    color: #999;
                    font-style: italic;
                }
                /* Modal Styles */
                .modal-overlayyz {
                    position: fixed;
                    top: 0;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    background: rgba(0,0,0,0.6);
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    z-index: 10000;
                    animation: fadeIn 0.3s ease;
                    padding: 20px;
                }
                @keyframes fadeIn {
                    from { opacity: 0; }
                    to { opacity: 1; }
                }
                @keyframes slideUp {
                    from { transform: translateY(30px) scale(0.95); opacity: 0; }
                    to { transform: translateY(0) scale(1); opacity: 1; }
                }
                .modal-contentyz {
                    background: white;
                    border-radius: 16px;
                    max-width: 550px;
                    width: 100%;
                    max-height: 85vh;
                    overflow-y: auto;
                    scrollbar-width:none;
                    animation: slideUp 0.3s ease;
                    box-shadow: 0 20px 60px rgba(0,0,0,0.3);
                }
                .modal-header-custom {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    padding: 20px 24px;
                    border-bottom: 1px solid #f0f0f0;
                    background: linear-gradient(135deg, #e66d33, #d45a2a);
                    border-radius: 16px 16px 0 0;
                }
                .modal-title {
                    margin: 0;
                    color: white;
                    font-weight: 600;
                    font-size: 1.2rem;
                }
                .modal-close-btn {
                    background: none;
                    border: none;
                    color: white;
                    font-size: 28px;
                    cursor: pointer;
                    padding: 0 8px;
                    opacity: 0.8;
                    transition: all 0.3s ease;
                }
                .modal-close-btn:hover {
                    opacity: 1;
                    transform: rotate(90deg);
                }
                .modal-body-custom {
                    padding: 24px;
                }
                .user-profile-details {
                    display: flex;
                    flex-direction: column;
                    gap: 12px;
                }
                .profile-row {
                    display: flex;
                    padding: 8px 0;
                    border-bottom: 1px solid #f5f5f5;
                }
                .profile-row:last-child {
                    border-bottom: none;
                }
                .profile-label {
                    font-weight: 600;
                    color: #555;
                    min-width: 140px;
                    font-size: 0.9rem;
                }
                .profile-value {
                    flex: 1;
                    color: #333;
                    font-size: 0.9rem;
                    word-break: break-word;
                }
                .profile-image {
                    width: 80px;
                    height: 80px;
                    border-radius: 50%;
                    object-fit: cover;
                    border: 3px solid #e66d33;
                }
                .modal-footer-custom {
                    padding: 16px 24px;
                    border-top: 1px solid #f0f0f0;
                    text-align: right;
                }
                .btn-close-modal {
                    padding: 8px 24px;
                    border: none;
                    border-radius: 8px;
                    background: #6c757d;
                    color: white;
                    font-weight: 500;
                    cursor: pointer;
                    transition: all 0.3s ease;
                }
                .btn-close-modal:hover {
                    background: #5a6268;
                    transform: scale(1.02);
                }
                .modal-loading {
                    text-align: center;
                    padding: 20px;
                    color: #999;
                }
                .profile-loader-overlay {
                    position: fixed;
                    top: 0;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    background: rgba(0,0,0,0.95);
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    z-index: 999998;
                    transition: opacity 0.4s ease;
                }
                /* Responsive */
                @media (max-width: 1024px) {
                    .filter-group {
                        flex: 1 1 100%;
                    }
                    .search-group {
                        min-width: 200px;
                    }
                    .action-group {
                        flex: 1 1 100%;
                        justify-content: flex-start;
                    }
                }
                @media (max-width: 768px) {
                    .filters-row {
                        flex-direction: column;
                        align-items: stretch;
                    }
                    .filter-group {
                        flex-direction: column;
                        align-items: stretch;
                    }
                    .search-group {
                        flex-direction: column;
                        border: 1px solid #e0e0e0;
                        border-radius: 8px;
                        min-width: unset;
                    }
                    .search-select {
                        border-right: none;
                        border-bottom: 1px solid #e0e0e0;
                        border-radius: 8px 8px 0 0;
                        width: 100%;
                    }
                    .search-input {
                        border-radius: 0 0 8px 8px;
                        width: 100%;
                    }
                    .date-input,
                    .status-select {
                        width: 100%;
                    }
                    .action-group {
                        flex-direction: column;
                        width: 100%;
                    }
                    .btn-clear,
                    .btn-export {
                        width: 100%;
                        justify-content: center;
                    }
                    .table-header th {
                        font-size: 0.7rem;
                        padding: 8px 4px;
                    }
                    .table-body td {
                        font-size: 0.75rem;
                        padding: 8px 4px;
                    }
                    .modal-content {
                        max-width: 95%;
                        margin: 10px;
                    }
                    .profile-row {
                        flex-direction: column;
                        gap: 4px;
                    }
                    .profile-label {
                        min-width: unset;
                        font-size: 0.8rem;
                    }
                    .profile-value {
                        font-size: 0.85rem;
                    }
                }
                @media (max-width: 480px) {
                    .table-header th {
                        font-size: 0.6rem;
                        padding: 6px 2px;
                    }
                    .table-body td {
                        font-size: 0.65rem;
                        padding: 6px 2px;
                    }
                    .btn-view {
                        padding: 3px 8px;
                        font-size: 0.65rem;
                    }
                    .status-badge,
                    .user-type-badge {
                        font-size: 0.6rem;
                        padding: 1px 8px;
                    }
                    .modal-header-custom {
                        padding: 16px;
                    }
                    .modal-title {
                        font-size: 1rem;
                    }
                    .modal-body-custom {
                        padding: 16px;
                    }
                    .profile-image {
                        width: 60px;
                        height: 60px;
                    }
                }
            `}</style>
        </div>
    );
};

export default Userdetails;